
<div>
    <app-bar :title="t('premium_personalized_plans_title')"></app-bar>

    <v-layout>
        <v-progress-linear
            v-if="overlay"
            absolute
            indeterminate
        ></v-progress-linear>

        <card-collection
            :meta="meta"
            :busy="overlay"
            @updated="updated"
        >
            <template #filters>
                <v-toolbar
                    elevation="0"
                    color="transparent"
                    class="mt-7"
                    height="56"
                >
                    <v-text-field
                        v-model="queries.search"
                        @click:clear="clearSearch"
                        class="input-search md mr-2"
                        clearable
                        outlined
                        dense
                        hide-details
                        prepend-inner-icon="mdi-magnify"
                        :label="t('general_label_search')"
                    ></v-text-field>

                    <v-select
                        v-model="queries.legacy"
                        :items="[
                            { text: '-', value: '' },
                            { text: t('general_text_yes'), value: '1' },
                            { text: t('general_text_no'), value: '0' },
                        ]"
                        class="md mr-2"
                        outlined
                        dense
                        append-icon="mdi-chevron-down"
                        hide-details
                        :label="t('premium_label_legacy')"
                    ></v-select>

                    <v-select
                        v-model="queries.plan_activated"
                        :items="[
                            { text: '-', value: '' },
                            { text: t('general_text_yes'), value: '1' },
                            { text: t('general_text_no'), value: '0' },
                        ]"
                        class="md mr-2"
                        outlined
                        dense
                        append-icon="mdi-chevron-down"
                        hide-details
                        :label="t('premium_label_plan_activated')"
                    ></v-select>

                    <v-select
                        v-model="queries.trial"
                        :items="[
                            { text: '-', value: '' },
                            { text: t('general_text_yes'), value: '1' },
                            { text: t('general_text_no'), value: '0' },
                        ]"
                        class="md mr-2"
                        outlined
                        dense
                        append-icon="mdi-chevron-down"
                        hide-details
                        :label="t('premium_label_trial')"
                    ></v-select>

                    <v-btn
                        @click="search"
                        class="sm mx-5"
                        color="primary"
                    >{{ t('general_action_search') }}</v-btn>

                    <v-spacer></v-spacer>

                    <v-btn
                        v-ripple="false"
                        plain
                        color="orange darken-4"
                        @click="reset"
                    >{{ t('general_action_reset_filters') }}</v-btn>
                </v-toolbar>
            </template>

            <template #data>
                <thead>
                <tr>
                    <th>{{ t('premium_label_user_id') }}</th>
                    <th>{{ t('premium_label_first_name') }}</th>
                    <th>{{ t('premium_label_last_name') }}</th>
                    <th>{{ t('user_label_email_address') }}</th>
                    <th>{{ t('premium_label_country') }}</th>
                    <th>{{ t('premium_label_legacy') }}</th>
                    <th>{{ t('premium_label_eligible_for_30d_trial') }}</th>
                    <th>{{ t('premium_label_plan_activated') }}</th>
                    <th>{{ t('premium_label_trial') }}</th>
                    <th>{{ t('premium_label_product_id') }}</th>
                    <th>{{ t('premium_label_programs_count') }}</th>
                    <th>{{ t('premium_label_program_name') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="collection.data.length === 0">
                    <td class="text-center" colspan="12">{{ t('general_text_no_data') }}</td>
                </tr>
                <tr v-for="item in collection.data" :key="item.id">
                    <td>{{ item.userId }}</td>
                    <td>{{ item.firstName }}</td>
                    <td>{{ item.lastName }}</td>
                    <td>{{ item.email }}</td>
                    <td>{{ item.country }}</td>
                    <td>{{ item.legacy ? t('general_text_yes') : t('general_text_no') }}</td>
                    <td>{{ item.eligibleFor30dTrial ? t('general_text_yes') : t('general_text_no') }}</td>
                    <td>{{ item.planActivated ? t('general_text_yes') : t('general_text_no') }}</td>
                    <td>{{ item.trial ? t('general_text_yes') : t('general_text_no') }}</td>
                    <td>{{ item.productId }}</td>
                    <td>{{ item.programsCount }}</td>
                    <td>{{ item.programName }}</td>
                </tr>
                </tbody>
            </template>
            <template #export>
                <v-btn
                    @click="_export"
                    class="exs mt-4 ml-4"
                    color="primary"
                    small
                >{{ t('general_action_export') }}</v-btn>
            </template>
        </card-collection>
    </v-layout>
</div>
